import { z } from "zod/v4";

export const StripeApiCustomerDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.email().nullish(),
  billing: z.boolean(),
  hasActiveStripeSubscription: z.boolean().nullish(),
  hasActiveShopifySubscription: z.boolean().nullish(),
});

export type StripeApiCustomerDto = z.infer<typeof StripeApiCustomerDtoSchema>;
